import React, {useEffect, useState} from 'react';
import {actionIcDescription24px, navigationIcClose24px} from '@ey/motif-react-wrapper/assets/icons/index';
import styled from 'styled-components';
import EllipseControl from '../../EllipsesControl/EllipsesControl';
import {labels} from '../../../../util/utils';
import Utility from '../../../../util/utilityfunctions';
import Dropdown from '../../BaseComponentWrappers/MotifDropdown';
import IconButton from '../../BaseComponentWrappers/MotifIconButton';
import Icon from '../../BaseComponentWrappers/MotifIcon';

export const RelatedCanvasForm = (props) => {
	const {relatedCanvasFormDetails, documentEngagementId} = props;
	const [firstRelatedCanvasFormDetails, setFirstRelatedCanvasFormDetails] = useState([]);
	const [secondRelatedCanvasFormDetails, setSecondRelatedCanvasFormDetails] = useState([]);
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		let primaryFormDetails = [];
		if (
			relatedCanvasFormDetails &&
			relatedCanvasFormDetails.primaryRelatedCanvasForm &&
			relatedCanvasFormDetails.primaryRelatedCanvasForm.length
		) {
			relatedCanvasFormDetails.primaryRelatedCanvasForm.map((primaryRelatedCanvasForm) => {
				let iPrimaryFormIndex = primaryFormDetails.findIndex(
					(f) => f.documentId === primaryRelatedCanvasForm.documentId
				);
				if (iPrimaryFormIndex === -1) {
					primaryFormDetails.push({
						documentId: primaryRelatedCanvasForm.documentId,
						documentName: primaryRelatedCanvasForm.documentName
					});
				}
			});

			setFirstRelatedCanvasFormDetails(primaryFormDetails);
		}
		let secondaryFormDetails = [];
		if (
			relatedCanvasFormDetails &&
			relatedCanvasFormDetails.secondaryRelatedCanvasForm &&
			relatedCanvasFormDetails.secondaryRelatedCanvasForm.length
		) {
			relatedCanvasFormDetails.secondaryRelatedCanvasForm.map((secondaryCanvasForm) => {
				let iSecondaryFormIndex = secondaryFormDetails.findIndex(
					(f) => f.documentId === secondaryCanvasForm.documentId
				);
				if (iSecondaryFormIndex === -1) {
					secondaryFormDetails.push({
						documentId: secondaryCanvasForm.documentId,
						documentName: secondaryCanvasForm.documentName
					});
				}
			});

			setSecondRelatedCanvasFormDetails(secondaryFormDetails);
		}
	}, [relatedCanvasFormDetails]);

	return (
		<StyledRelatedCanvasaForm className="StyledRelatedCanvasaForm">
			{relatedCanvasFormDetails && relatedCanvasFormDetails.formSectionId && (
				<Dropdown
					handleClickOutside={() => setIsOpen(false)}
					open={isOpen}
					portalClassName="contentUpdateTooltip RelatedCanvasaForm-dropdown"
					usePortal
					trigger={
						<IconButton
							ariaLabel="Tooltip"
							type="button"
							onClick={() => setIsOpen(true)}
							title={labels.relatedCanvasForm}
							iconSource={actionIcDescription24px}
						/>
					}
					closeButtonProps={{
						title: labels.closeLabel,
						'aria-label': labels.closeLabel
					}}
					children={
						<section className="relatedCanvasFormContainer">
							{firstRelatedCanvasFormDetails && firstRelatedCanvasFormDetails.length > 0 && (
								<section className="relatedCanvasFormWrapper relatedCanvasForm">
									<section className="relatedCanvasFormHeading">
										<EllipseControl
											content={labels.primaryRelated}
											tooltip={labels.primaryRelated}
											displayId={''}
											noOfLines={1}
										/>
										<span className="inputMotifIcon cancelBtn" onClick={() => setIsOpen(false)}>
											<Icon src={navigationIcClose24px} title={labels.cancelLabel} />
										</span>
									</section>
									{firstRelatedCanvasFormDetails
										.sort(Utility.sortByMultipleKey('documentName'))
										.map((primaryRelatedCanvasForm) => {
											let urlFirstFormPath =
												new URL(window.location.origin) +
												`canvasform?engagementid=${documentEngagementId}&documentid=${
													primaryRelatedCanvasForm.documentId
												}&referrer=${new URL(window.location.href)}`;
											return (
												<section className="relatedCanvasFormDocName relatedCanvasFormText">
													<EllipseControl
														content={primaryRelatedCanvasForm.documentName}
														tooltip={primaryRelatedCanvasForm.documentName}
														displayId={''}
														noOfLines={1}
														link={urlFirstFormPath}
													/>
												</section>
											);
										})}
								</section>
							)}
							{secondRelatedCanvasFormDetails && secondRelatedCanvasFormDetails.length > 0 && (
								<section className="relatedCanvasFormWrapper relatedCanvasForm">
									<section className="relatedCanvasFormHeading">
										<EllipseControl
											content={labels.secondaryRelated}
											tooltip={labels.secondaryRelated}
											displayId={''}
											noOfLines={1}
										/>
										<span
											className={`inputMotifIcon cancelBtn ${firstRelatedCanvasFormDetails.length > 0 && 'hide'}`}
											onClick={() => setIsOpen(false)}
										>
											<Icon src={navigationIcClose24px} title={labels.cancelLabel} />
										</span>
									</section>
									{secondRelatedCanvasFormDetails
										.sort(Utility.sortByMultipleKey('documentName'))
										.map((secondaryRelatedCanvasForm) => {
											let urlSecondFormPath =
												new URL(window.location.origin) +
												`canvasform?engagementid=${documentEngagementId}&documentid=${
													secondaryRelatedCanvasForm.documentId
												}&referrer=${new URL(window.location.href)}`;
											return (
												<section className="relatedCanvasFormDocName relatedCanvasFormText">
													<EllipseControl
														content={secondaryRelatedCanvasForm.documentName}
														tooltip={secondaryRelatedCanvasForm.documentName}
														displayId={''}
														noOfLines={1}
														link={urlSecondFormPath}
													/>
												</section>
											);
										})}
								</section>
							)}
						</section>
					}
				/>
			)}
		</StyledRelatedCanvasaForm>
	);
};

const StyledRelatedCanvasaForm = styled.section`
	display: flex;
	width: var(--px-24);
	height: var(--px-24);
	.motif-dropdown-portal .motif-dropdown-trigger .motif-button {
		background: transparent !important;
		padding: 0 !important;
	}
	.motif-tooltip-wrapper {
		width: 100%;
		height: 100%;
		.motif-tooltip-trigger-wrap {
			width: 100%;
			height: 100%;
			.motif-button {
				width: 100%;
				height: 100%;
				.motif-icon {
					display: flex;
					svg {
						width: var(--px-24) !important;
						height: var(--px-24) !important;
					}
				}
				&:hover,
				&:focus {
					box-shadow: none;
				}
			}
		}
	}
`;
